import { Spinner, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { Center, Flex, styled } from "styled-system/jsx";

type UploadingMediaProps = {
  uploaderType: "default" | "singleCompactUploader";
  containerClassName?: string;
};

const UploadingMediaContainer = styled(Center, {
  base: {
    borderWidth: "1px",
    borderColor: "border.light",
  },
  variants: {
    uploaderType: {
      default: {
        background: "bg.wa.light",
        minHeight: "xs",
        borderRadius: "150",
        borderStyle: "solid",
        px: "300",
        py: "200",
      },
      singleCompactUploader: {
        background: "bg.subtlest",
        borderRadius: "100",
        borderStyle: "dashed",
        px: "300",
        py: "250",
      },
    },
  },
  defaultVariants: {
    uploaderType: "default",
  },
});

export const UploadingMedia = ({
  uploaderType,
  containerClassName,
}: UploadingMediaProps) => {
  const { t } = useTranslation("core");

  return (
    <UploadingMediaContainer
      uploaderType={uploaderType}
      className={containerClassName}
    >
      <Flex
        height={"48px"}
        alignItems={"center"}
        justifyContent={"center"}
        gap={"100"}
        width={"full"}
      >
        <Spinner width={"24px"} height={"24px"} />
        <Text visual={"bodyMedium"} color={"text.mid"}>
          {t("IMAGE.UPLOAD.UPLOADING_SHORT")}...
        </Text>
      </Flex>
    </UploadingMediaContainer>
  );
};
